import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";

type NoAcoSectionContentType = {
  policyExtraTitle: string;
  policyExtraDescription: string;
};

function NoAcoSection({
  policyExtraTitle,
  policyExtraDescription,
}: Readonly<NoAcoSectionContentType>) {
  return (
    <div data-testid="NoAcoSection-test-id">
      <div
        className="md:max-w-[1200px]  min-w-[312px] mx-spacing-l md:mx-spacing-xxl lg:mx-auto my-0 md:w-auto relative bg-surface-neutral-option-1 
md:p-spacing-xxl p-spacing-m rounded-radius-xxl"
      >
        <div className="mb-spacing-l font-header-font text-[26px] md:text-[39px] leading-[115%] font-[400] text-text-title">
          {policyExtraTitle}
        </div>
        <div>
          <RichText
            richText={policyExtraDescription}
            className="!text-xs !font-[400] !leading-custom-size-xxl !text-text-functional"
          />
        </div>
      </div>
    </div>
  );
}

export default NoAcoSection;
